import { ScoreMetricsTableDataStructureRow } from '../../types';
import { SAASSCORE_SHARED_METRICS } from '../../constants';

export const detectSharedMetric = (row: ScoreMetricsTableDataStructureRow): boolean => {
  return Boolean(typeof row !== 'string' && SAASSCORE_SHARED_METRICS.includes(row.code));
};
